// Sorts a list of items by weighting, and if weights are equal
// sorts those items by alphabetical order.
export const sortByWeightAndAlphabetical = ({
  list,
  weightKey,
  alphabeticalKey,
}) => {
  return [...list].sort((a, b) => {
    if (a[weightKey] === b[weightKey]) {
      const nameA = a[alphabeticalKey].toLowerCase();
      const nameB = b[alphabeticalKey].toLowerCase();

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    }

    return a[weightKey] - b[weightKey];
  });
};
